import styled from 'styled-components'
import { rgba } from 'polished'

// Utils
import { breakpoint } from 'utils'

// Components
import Modal from 'components/Modal'

// Local Components
import { MembersList, ModalWarning } from 'modules/workspace/components'

export const ModalDialog = styled(Modal)`
  ${breakpoint('sm')`
    max-width: 925px;
  `}
`

export const StyledModalWarning = styled(ModalWarning)`
  margin-top: 30px; /* stylelint-disable-line scales/space */
`

export const ModalBody = styled(Modal.Body)`
  display: flex;
  margin-top: 45px; /* stylelint-disable-line scales/space */

  ${breakpoint('base', 'sm')`
    flex-direction: column;
  `}
`

export const Column = styled.div`
  width: auto;

  &:first-child {
    ${breakpoint('sm')`
      width: calc(55% - 15px);
    `}
  }

  &:nth-child(2) {
    ${breakpoint('sm')`
      width: calc(45% - 15px);
      margin-left: 30px; /* stylelint-disable-line scales/space */
    `}

    ${({ theme }) => breakpoint('base', 'sm')`
        border-top: 1px solid ${rgba(theme.colors.black, 0.1)};
        margin: -40px -40px 0 -40px;
        padding: 40px 40px 0px 40px;
    `}
  }
`

export const StyledSummaryWrapper = styled.div`
  ${({ theme }) => breakpoint('sm', 'xxl')`
    padding: 10px 20px;
    margin-bottom: 30px;
    background-color: ${theme.colors.background.light.secondary};
    border: 1px solid ${rgba(theme.colors.black, 0.1)};
    box-shadow: ${theme.shadows.boxShadow.subtle};
    border-radius: 4px;
  `}
`

export const StyledMemberList = styled(MembersList)`
  /* Space between the members section and the bottom component */
  margin-bottom: 32px;
`

export const DiscountWrapper = styled.div`
  margin-bottom: 16px;
  padding: 16px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.dark.base};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};
`
